import { Sparkles, AlertTriangle, X } from 'lucide-react';
import type { Role } from '@/types/api';

interface Props {
  open: boolean;
  onClose: () => void;
  role: Role;
}

const NOTES_BY_ROLE: Partial<Record<Role, string[]>> = {
  curator: [
    'Замечание №9 (критическое) открыто 25 дн., нет ответа от ГИП',
    '3 пробела комплектности в разделе ПОС требуют пополнения до конца недели',
    'Раздел ТКР редакции №3 содержит 2 предупреждения парсинга',
    'Срок ответа по замечанию №6 истекает завтра',
  ],
  expert: [
    'У вас 2 замечания со статусом «уточнить» — ГИП ответил, нужна проверка',
    'Конфликт по ТКР: №2 противоречит решению по №6',
    'Новых назначений: 1',
  ],
  gip: [
    'Замечание №9 — расчёт уклона: срок истёк 4 дн. назад',
    'По №6 нужно приложить расчётное обоснование радиуса',
    'Шаблон расчёта в RAG-индексе',
  ],
  admin: [
    'Завершить пилот UI v2 для 5 проектов',
    'Переиндексация RAG занимает > 1ч — проверить логи',
    'Срок продления домена через 30 дн.',
  ],
};

/** Sticky-panel со сгенерированной ИИ-сводкой для текущей роли. */
export function AIViewPanel({ open, onClose, role }: Props) {
  if (!open) return null;
  const notes = NOTES_BY_ROLE[role] || NOTES_BY_ROLE.curator!;
  const roleLabel = ({ curator: 'куратор', expert: 'эксперт', gip: 'ГИП', admin: 'админ', customer: 'заказчик' } as Record<Role, string>)[role];
  return (
    <div
      className="fixed bg-white rounded-card flex flex-col"
      style={{
        top: 180, right: 24, width: 360, maxHeight: '60vh', overflowY: 'auto',
        border: '1px solid #E5E7EB',
        boxShadow: '0 16px 48px rgba(10,22,40,.16)',
        zIndex: 30,
      }}
      role="region"
      aria-label="ИИ-сводка"
    >
      <div
        className="flex justify-between items-center"
        style={{ padding: '12px 16px', borderBottom: '1px solid #E5E7EB', background: 'rgba(245,158,11,.05)' }}
      >
        <div className="flex items-center" style={{ gap: 8 }}>
          <Sparkles size={16} stroke="#F59E0B" />
          <span style={{ fontSize: 13, fontWeight: 600, color: '#0A1628' }}>ИИ-сводка для роли {roleLabel}</span>
        </div>
        <button type="button" onClick={onClose} className="text-muted" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }} aria-label="Закрыть">
          <X size={16} />
        </button>
      </div>
      <div style={{ padding: 16 }}>
        <div className="text-muted" style={{ fontSize: 11, fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase' }}>На что обратить внимание</div>
        <div className="mt-3 flex flex-col" style={{ gap: 12 }}>
          {notes.map((t, i) => (
            <div key={i} className="flex items-start" style={{ gap: 10 }}>
              <AlertTriangle size={14} stroke="#F59E0B" className="shrink-0 mt-0.5" />
              <span className="text-ink" style={{ fontSize: 13, lineHeight: 1.5 }}>{t}</span>
            </div>
          ))}
        </div>
        <div className="border-t border-border mt-4 pt-3 text-muted" style={{ fontSize: 12 }}>
          Сгенерировано 2 минуты назад · GPT-4o
        </div>
        {/* Кнопка «Обновить сводку» убрана: backend-endpoint пересборки AI-сводки
            пока не реализован. Добавим обратно когда появится endpoint. */}
      </div>
    </div>
  );
}
